module.exports = __webpack_public_path__ + "static/media/hyakusen.69529ea9.png";